import { Expense, ItemSplit, Tax } from "@finway-group/shared/lib/models"
import { Button, Col, Row } from "antd"
import React from "react"
import { Plus as PlusIcon, Trash2 as TrashIcon } from "react-feather"
import { ExpenseData } from "~Components/modals/expenseCreateForm.context"
import { expenseInitializer } from "~Features/pages/expenses/expenseInitializer"
import { syncTotalExpenseAmountsToItems } from "~Shared/utils/expense.utils"

export interface FormItemSideButtonsInterface {
    elem: {
        fieldsLength: number
        index: number
        onRemoveClick: (index: number | Array<number>) => void
        updateExpense: (data: ExpenseData) => void
        expense: Expense
        isHospitality: boolean
        isTipRow: boolean
        taxValues: Array<Tax>
        onAddClick: (defaultValue?: ItemSplit, insertIndex?: number) => void
    }
    span?: number
    md?: number | object
    sm?: number | object
}

function FormItemSideButtons({ elem, ...columnProps }: FormItemSideButtonsInterface) {
    const { fieldsLength, index, onRemoveClick, updateExpense, expense, isHospitality, isTipRow, taxValues, onAddClick } = elem

    const handleRemoveClick = () => {
        onRemoveClick(index)
        const newSplits = expense.splits.filter((_split, i) => i !== index)
        updateExpense(syncTotalExpenseAmountsToItems(newSplits))
    }

    const handleAddClick = () => {
        const insertIndex = index + 1
        const costPropsDefaults = {
            costCenter: expense?.costCenter,
            costCenter2: expense?.costCenter2,
            expenseAccount: expense?.expenseAccount,
        }
        const newItem = expenseInitializer.initializeNewItemSplit(taxValues, costPropsDefaults, expense.kind)
        onAddClick(newItem, insertIndex)
        const items = [...expense.splits]
        items.splice(insertIndex, 0, newItem)
        updateExpense({ splits: items })
    }

    return (
        <Col {...columnProps}>
            {fieldsLength > 0 && (
                <Row>
                    <Col>
                        <Button onClick={handleRemoveClick} disabled={isHospitality && expense.splits.length <= 1}>
                            <TrashIcon />
                        </Button>
                    </Col>
                </Row>
            )}
            {!isTipRow && (
                <>
                    <Row>
                        <div role="none" style={{ height: "4px" }} /> {/** Just a visual spacer */}
                    </Row>
                    <Row>
                        <Col>
                            <Button onClick={handleAddClick}>
                                <PlusIcon />
                            </Button>
                        </Col>
                    </Row>
                </>
            )}
        </Col>
    )
}

export default React.memo(FormItemSideButtons)
